// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__EeHoV","load":"Spinner_load__3+qhm"};